var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSocialMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0244 22.5V2.5H21.561V22.5H19.0244ZM0 25V0H16.4878V25H0ZM24.0976 20V5H26V20H24.0976ZM2.53659 22.5H13.9512V2.5H2.53659V22.5Z",
    fill: "#674366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSocialMediaIcon);
export default __webpack_public_path__ + "static/media/ai_social_media_icon.917245b936d676ab72c5f856992d07f2.svg";
export { ForwardRef as ReactComponent };